import React from "react";

const ScormIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23.964"
      height="19.506"
      viewBox="0 0 23.964 19.506"
    >
      <g id="db38" transform="translate(-172.366 -210.25)">
        <path
          id="Path_1274"
          data-name="Path 1274"
          d="M254.823,314.718v1.115a.279.279,0,0,1-.279.279H238.94a.279.279,0,0,1-.279-.279v-1.115a.279.279,0,0,1,.279-.279h15.605A.278.278,0,0,1,254.823,314.718Z"
          transform="translate(-62.394 -98.059)"
          fill={fill ? fill : "#707070"}
        />
        <path
          id="Path_1275"
          data-name="Path 1275"
          d="M246.185,371.544v5.573a.279.279,0,0,1-.279.279H238.94a.279.279,0,0,1-.279-.279v-5.573a.279.279,0,0,1,.279-.279h6.966a.279.279,0,0,1,.279.279Z"
          transform="translate(-62.394 -151.541)"
          fill={fill ? fill : "#707070"}
        />
        <path
          id="Path_1276"
          data-name="Path 1276"
          d="M393,371.544v5.573a.279.279,0,0,1-.279.279H385.75a.279.279,0,0,1-.279-.279v-5.573a.279.279,0,0,1,.279-.279h6.966a.279.279,0,0,1,.279.279Z"
          transform="translate(-200.566 -151.541)"
          fill={fill ? fill : "#707070"}
        />
        <path
          id="Path_1277"
          data-name="Path 1277"
          d="M194.658,210.25H174.038a1.672,1.672,0,0,0-1.672,1.672v16.162a1.672,1.672,0,0,0,1.672,1.672h20.621a1.672,1.672,0,0,0,1.672-1.672V211.922A1.672,1.672,0,0,0,194.658,210.25Zm-1.951,1.115a.836.836,0,1,1-.836.836A.836.836,0,0,1,192.708,211.365Zm-3.344,0a.836.836,0,1,1-.836.836A.836.836,0,0,1,189.364,211.365Zm-3.344,0a.836.836,0,1,1-.836.836A.836.836,0,0,1,186.02,211.365Zm8.638,16.441a.279.279,0,0,1-.279.279H174.317a.279.279,0,0,1-.279-.279V214.429a.279.279,0,0,1,.279-.279H194.38a.279.279,0,0,1,.279.279Z"
          transform="translate(0)"
          fill={fill ? fill : "#707070"}
        />
      </g>
    </svg>
  );
};

export default ScormIcon;
